import { AgExpandCellRendererComponent } from 'components/AgGrid/AgExpandCellRendererComponent';
import type { WorkOrderChangeObjectItem, WorkOrderObjectData } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import type { CellClassParams } from 'ag-grid-community/dist/types/core/entities/colDef';
import { useCallback, useMemo } from 'react';

import { HierarchyNameCellRenderer } from '../components/HierarchyNameCellRenderer';

interface IUseWorkOrderObjectTotalColumns {
    onExpandDetailsClick: (data: WorkOrderObjectData | WorkOrderChangeObjectItem) => void;
    actualItems: WorkOrderObjectData[] | WorkOrderChangeObjectItem[];
}

const cellClass = (cellClassParams: CellClassParams<WorkOrderObjectData>) =>
    !cellClassParams?.data?.parentId ? 'head-line' : 'ordinary-line';

export const useWorkOrderObjectTotalColumns = (props: IUseWorkOrderObjectTotalColumns) => {
    const { onExpandDetailsClick, actualItems } = props;

    const isInvisible = useCallback(
        (data?: WorkOrderObjectData | WorkOrderChangeObjectItem) =>
            data?.parentId && (actualItems as any).find((i: any) => i.parentId === data.id),
        [actualItems],
    );

    return useMemo<ColDef<WorkOrderObjectData>[]>(
        () => [
            {
                width: 50,
                cellRenderer: AgExpandCellRendererComponent,
                cellRendererParams: {
                    onClick: onExpandDetailsClick,
                    isInvisible,
                },
                cellClass,
            },
            { headerName: 'Наименование', field: 'name', flex: 1, cellClass, cellRenderer: HierarchyNameCellRenderer },
        ],
        [onExpandDetailsClick, isInvisible],
    );
};
